import CheckCircleIcon from "@mui/icons-material/Check";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import React from "react";
import { getGridWord } from "./GridCandUtils";

export default function GridCandEntry({
    candidate,
    isSelected,
    onWordSelect,
    onWordAdd}) {
    return (
        <ListItem divider disablePadding>
            <Box sx={{ position: 'relative', width: '100%' }}>
                <ListItemButton
                    selected={isSelected}
                    onClick={() => onWordSelect(candidate)}
                    sx={{ pr: 6 }} // Add right padding for the icon button
                >
                    <ListItemText
                        primary={
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <Typography variant="h6" component="span">
                                    {candidate.word}
                                </Typography>
                                <Chip
                                    label={candidate.direction}
                                    size="small"
                                    color="primary"
                                    sx={{
                                        ...(candidate.direction === 'scattered' && {
                                            backgroundColor: '#ce93d8', // MUI purple 200
                                            color: '#4a148c' // purple 900 for contrast
                                        })
                                    }}
                                />
                                <Chip
                                    label={`Score: ${candidate.score || 0}`}
                                    size="small"
                                    color="secondary"
                                />
                            </Box>
                        }
                        secondary={
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                                Row: {candidate.startRow} | Col: {candidate.startCol} | Direction: {candidate.direction} | Length: {(candidate.gridWord || getGridWord(candidate.word)).length}
                            </Typography>
                        }
                    />
                </ListItemButton>
                
                {/* Add button positioned in top-right corner */}
                <Tooltip title="Add This Word to the puzzle as you decided the position">
                    <IconButton
                        onClick={(e) => {
                            e.stopPropagation();
                            onWordAdd(candidate);
                        }}
                        size="small"
                        color="primary"
                        sx={{
                            position: 'absolute',
                            top: 8,
                            right: 8
                        }}
                    >
                        <CheckCircleIcon />
                    </IconButton>
                </Tooltip>
            </Box>
        </ListItem>
    );
}

